module.exports = __webpack_public_path__ + "img/blanket_inDrawing.30dfa069.png";